[{
        "coreStep": "Final Contract Documentation",
        "generalTask": "Prepare Final Contract Documentation",
        "actionDetails": "<ul><li>Create final contract - Firm Order Contract stands as previously agreed or update per Client's instructions and market(s) agreement<\/li><li>Create final I&L’s Documents for each market including the Final Signed Line<\/li><\/ul>",
        "responsibility": "CD",
        "cemRequirement": "No",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "Final Contract Documentation",
        "generalTask": "SPOE",
        "actionDetails": "<ul><li>Final contract and I&L's to be submitted for SPOE and approved by authorized SPOE prior to sending to the client and to the markets<\/li><\/ul>",
        "responsibility": "CD\/BT",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": "<a href='https://ajg0.sharepoint.com/sites/gre-Gateway/_layouts/15/download.aspx?UniqueId=b2690527%2Deb94%2D4938%2D917c%2D548936b13995', target = \"_self\">GEM Authorized Second Pair of Eyes List<\/a>"
    },
    {
        "coreStep": "Final Contract Documentation",
        "generalTask": "Send to Client",
        "actionDetails": "<ul><li>Send the final contract using appropriate Template Text to the Client for signing<\/li><li>Include the Senior Broker, Broker Team, Contract Drafter, and Ops Specialist<\/li><\/ul>",
        "responsibility": "CD\/BT",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "Final Contract Documentation",
        "generalTask": "Client Signing",
        "actionDetails": "<ul><li>Must advise Client if any changes to contract were made between firm order version and final version, and obtain Client's approval of the final contract wording prior to its distribution to markets<\/li><li>Obtain Client's signed final contract<\/li><\/ul>",
        "responsibility": "CD\/BT",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "Final Contract Documentation",
        "generalTask": "Send to Markets",
        "actionDetails": "<ul><li>Send markets notification of their final signed lines and transmit final contract and I&L’s for signing using appropriate Template Text<\/li><li>Include the Broker Team, Contract Drafter and Ops Specialist in transmittal email to Client<\/li><\/ul>",
        "responsibility": "CD\/BT",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "Final Contract Documentation",
        "generalTask": "Reinsurer Signing",
        "actionDetails": "<ul><li>Advise markets if any changes to contract were made between firm order version and final version<\/li><li>Obtain signed I&Ls from all markets<\/li><\/ul>",
        "responsibility": "BT\/CD",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "Final Contract Documentation",
        "generalTask": "Fully Executed Documentation",
        "actionDetails": "<ul><li>Fully signed contract documentation to be:<br \/>Provided to Contract Drafter for Contract Library filing<br \/>Provided to Ops Specialist<\/li><\/ul>",
        "responsibility": "BT\/CD",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "WIN",
        "generalTask": "WIN Updates",
        "actionDetails": "<ul><li>Update WIN with final Brokerage, both USA and London Share<\/li><li>Change the 'probability' to 100% and close the opportunity as \"WON\"<\/li><\/ul>",
        "responsibility": "BT",
        "cemRequirement": "No",
        "guidanceReferenceLink": "<a href=\"https:\/\/gallagherre.lightning.force.com\/\" target=\"_blank\">WIN Link</a>"
    },
    {
        "coreStep": "Wrap Up Book",
        "generalTask": "Create Wrap-up Book",
        "actionDetails": "<ul><li>Create a book (electronic or hard copy) for the Client memorialising completed placement<\/li><li>Wrap Up book may contain the following documents:<br \/>Placement Summary, Submission Document, Fully Signed Final Contracts - including all signed I&L's and additional documentation, Broker Team Contact Information, Client Services \"Claims Reporting Contacts & Procedures\" document<\/li><\/ul>",
        "responsibility": "BT",
        "cemRequirement": "No",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "Post Placement Review",
        "generalTask": "Review & Strategy Meeting",
        "actionDetails": "<ul><li>Meet with Broker Team, Analytics, Contracts Drafter, Ops Specialist and discuss issues encountered during the placement process and strategize for next renewal<\/li><\/ul>",
        "responsibility": "BT\/CD\/Analytics\/OS",
        "cemRequirement": "No",
        "guidanceReferenceLink": ""
    }
]
